<template>
	<div>
		<!-- <v-dialog v-model="dialog_parties" no-click-animation persistent scrollable content-class="full-height" transition="dialog-bottom-transition"> -->
		<!-- <v-bottom-sheet persistent v-model="dialog_parties" v-if="dialog_parties"> -->
		<dialog ref="ref_nativeDialog" class="native_sheet" v-if="dialog_parties" full-width>
	        <v-card flat class="dialog_sheet_native" v-if="propertyObj">
				<div class="sticky-header">
					<v-subheader class="pa-0">
						<v-btn icon class="mt-0 mb-0" @click="closeDialog"><v-icon>close</v-icon></v-btn>
						Select {{ propertyObj.ToolbarTitle }} 
						<v-spacer></v-spacer>
						<v-btn flat icon v-if="propertyObj.action" @click="newParty(null, null, propertyObj.action)">
							<v-icon color="primary">add</v-icon>
						</v-btn>
					</v-subheader>
					<v-text-field v-model="searchVal" @input="fn_debounceSearch(null)" clearable single-line solo flat placeholder="Search" hide-details class="bottomsheet-search" :height="42"></v-text-field>
					<div class="pl-3 pr-3 pt-1 pb-1" v-if="propertyObj.enableFilterChip">
						<v-chip style="border: 0 !important;" flat class="ma-0 mr-1" @click="fn_debounceSearch(101)" :class="{'primary-background-color whitecolor': selectedFilterChipId == 101}">Customer</v-chip>
						<v-chip style="border: 0 !important;" flat class="mr-0 mr-1" @click="fn_debounceSearch(102)" :class="{'primary-background-color whitecolor': selectedFilterChipId == 102}">Supplier</v-chip>
						<v-chip style="border: 0 !important;" flat class="mr-0 mr-1" @click="fn_debounceSearch(103)" :class="{'primary-background-color whitecolor': selectedFilterChipId == 103}">Other</v-chip>
					</div>
				</div>
		        <v-card-text full-height nopadding>

					<v-list-tile v-if="propertyObj && propertyObj.selectedItem && propertyObj.selectedItem.itemId && propertyObj.selectedItem.itemName && (!propertyObj.enableFilterChip || propertyObj.enableFilterChip && propertyObj.groupTypeId == selectedFilterChipId)"  @click="fn_setLedgder(propertyObj.selectedItem.itemId, propertyObj.selectedItem.itemName)">
						<v-list-tile-content>
							<v-list-tile-title>{{propertyObj.selectedItem.itemName}}</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon color="primary">radio_button_checked</v-icon>
						</v-list-tile-action>
					</v-list-tile>

			        <v-list nopadding v-if="parties && parties.length">
						<template v-for="(item, index) in parties">
							<v-list-tile v-if="!propertyObj.selectedItem || (propertyObj.selectedItem && propertyObj.selectedItem.itemId !=  item.itemId)" :key="index" @click="fn_setLedgder(item.itemId, item.itemName)">
								<v-list-tile-content>
								<v-list-tile-title>{{item.itemName}}</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon color="primary">radio_button_unchecked</v-icon>
									<!-- <v-icon :color="propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'primary' : ''">{{ propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon> -->
								</v-list-tile-action>
							</v-list-tile>
						</template>
			        </v-list>

					<div class="pa-4 center-align display_msg" v-if="!loading && (!parties || !parties.length)">
						No {{ propertyObj.ToolbarTitle.toLowerCase() }}  found!
						<!-- <v-btn small class="mt-4" capitalize outline color="primary" @click="newParty(menuItemClickParam)">
							<v-icon left class="mr-1 font16 primary-color">add</v-icon>Add New Party
						</v-btn> -->
					</div>

					<div class="pa-4 center-align display_msg" v-if="loading">
						Loading...
					</div>
		        </v-card-text>
		    </v-card>
		</dialog>
		<!-- </v-bottom-sheet> -->
	    <!-- </v-dialog> -->
	</div>
</template>

<script>
	export default{
		props:['newParty', 'closeDialog', 'fnOnChange'],
		data(){
			return{
				dialog_parties:false,
                parties:[],
				searchVal:null,
				timeoutid:null,
				loading:false,
				propertyObj:null,
				selectedFilterChipId:null,
				startIndex:0,
				totalItems:0,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchVal = null;
				this.propertyObj = localStorage.getItem('dialog_properties') ? JSON.parse(localStorage.getItem('dialog_properties')) : null;
				this.selectedFilterChipId = null;
				if(this.propertyObj.groupTypeId){
					this.selectedFilterChipId = this.propertyObj.groupTypeId;
				}
				this.dialog_parties = true;
				setTimeout(() => {
					this.$refs['ref_nativeDialog'].showModal();
				}, 100);

				this.$nextTick(() => {
					let element = document.getElementsByClassName("native_sheet")[0];
					element.addEventListener('scroll', this.fn_onScroll); 
				})

				this.startIndex = 0;
                this.fn_getParties();
			},
			closeDialogWeb: function () {
				let element = document.getElementsByClassName("native_sheet")[0];
				if(element){
					element.removeEventListener('scroll', this.fn_onScroll);
				}
				this.$refs['ref_nativeDialog'] ? this.$refs['ref_nativeDialog'].close() : '';
				this.dialog_parties = false;
				this.parties = []
			},
			fn_onScroll: function(event){
				if (Math.floor(event.target.scrollHeight - event.target.scrollTop) <= event.target.clientHeight)
				{
					console.log('scrolled');
					if(this.parties.length < this.totalItems){
						this.fn_getParties();
					}
					else{
						console.log("no more items to load");
					}
				}
			},
			fn_setLedgder: function(itemId, itemName){
				// this.propertyObj.fnSetLedger(itemId, itemName);
				this.fnOnChange(null, this.propertyObj.ref, itemId, itemName);
				this.closeDialog();
			},
			fn_debounceSearch: function(groupTypeId){
				if (this.timeoutid != null){
					clearTimeout(this.timeoutid);
				}

				this.timeoutid = setTimeout(() => { 
					this.parties = [];
					this.totalItems = 0;
					this.startIndex = 0;
					this.fn_getParties(groupTypeId);
				},300);
			},
            fn_getParties: function (groupTypeId) {
				this.loading = true;
				// this.parties = null;
                let filterObject = {};
                filterObject.search = this.searchVal ? this.searchVal.toLowerCase() : '';

				// if(this.propertyObj.accountGroups){
				// 	filterObject.accountGroupIds = this.propertyObj.accountGroups;
				// }

				if(groupTypeId || this.selectedFilterChipId){
					filterObject.groupTypeId = groupTypeId || this.selectedFilterChipId;
					this.selectedFilterChipId = groupTypeId || this.selectedFilterChipId;
				}
				else{
					filterObject.groupTypeId = this.propertyObj.groupTypeId ? this.propertyObj.groupTypeId : null;
				}

				if(this.propertyObj.accountGroups){
					filterObject.accountGroups = this.propertyObj.accountGroups;
				}

				if(this.propertyObj.accountGstTypes){
					filterObject.gstTypes = this.propertyObj.accountGstTypes;
				}
				
                // if(this.groupTypeId){
                //     filterObject.groupTypeId = this.groupTypeId;
                // }

				if(this.propertyObj.accountGroupIds){
					filterObject.accountGroupIds = this.propertyObj.accountGroupIds;
				}

				// filterObject.startIndex = 0;
				// filterObject.limit = 100;
				filterObject.startIndex = this.startIndex;
				filterObject.limit = 50;

                let self = this;
                this.getDialogItems("AccountDialog", filterObject, 
                    {
                        onSuccess: function(response){
                            console.log(response);
							let responseJson = JSON.parse(response);

							if(responseJson.items && responseJson.items.length){
								for(let i in responseJson.items){
									self.parties.push(responseJson.items[i]);
								}

								self.totalItems = responseJson.totalCount;
								self.startIndex = self.parties.length;
							}

							// if(self.propertyObj.selectedItem && self.propertyObj.selectedItem.itemId && self.parties && self.parties.length){
							// 	// finding index of selected item
							// 	let selectedItemIndex = self.parties.findIndex(item=>item.itemId === self.propertyObj.selectedItem.itemId);
							// 	let selectedItemGroupTypeId = null;
							// 	// removing selected item from the list
							// 	if(selectedItemIndex != -1){
							// 		selectedItemGroupTypeId = self.parties[selectedItemIndex].groupTypeId;
							// 		self.parties.splice(selectedItemIndex, 1);
							// 	}
							// 	// pushing selected item to the top
							// 	if(!self.propertyObj.enableFilterChip || (self.propertyObj.enableFilterChip && self.selectedFilterChipId == selectedItemGroupTypeId)){
							// 		self.parties.unshift(self.propertyObj.selectedItem);
							// 	}
							// }
							self.loading = false;
                        }, 
                        onError: function(error){
                            console.log(error);
							self.loading = false;
                        }
                    }
                );
            },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_parties.vue